var boxSelection = 0;
var boxSize = 4;
var boxPrice = 25;
var boxName = '';
let cookiesInCart = [];

var cookies = [];
var boxVariations = [];
var giftTypes = "Plain Card,Congrats!,Happy Birthday!,You're the Sweetest,Thank You,Happy Anniversary!,Happy Thanksgiving!";

var number = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen', 'Twenty', 'Twenty-One', 'Twenty-Two', 'Twenty-Three', 'Twenty-Four', 'Twenty-Five', 'Twenty-Six', 'Twenty-Seven', 'Twenty-Eight', 'Twenty-Nine', 'Thirty', 'Thirty-One', 'Thirty-Two'];

function createCookie(name, value, days) {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

var archieThemeSettingsPromise = null;

function getArchieThemeSettings() {
    if (archieThemeSettingsPromise) return archieThemeSettingsPromise;

    const query = new URLSearchParams();
    if (typeof shop !== "undefined" && shop) query.set("shop", shop);

    archieThemeSettingsPromise = fetch(`/apps/archie/theme-settings?${query.toString()}`)
        .then((response) => {
            if (!response.ok) throw new Error("Archie theme settings unavailable");
            return response.json();
        })
        .catch(() => ({
            orderMode: "bento",
            modalMode: "bento",
        }));

    return archieThemeSettingsPromise;
}

function buildQuery(params) {
    const query = new URLSearchParams();

    for (const key in params || {}) {
        if (!Object.prototype.hasOwnProperty.call(params, key)) continue;
        if (params[key] === undefined || params[key] === null) continue;
        query.set(key, params[key]);
    }

    return query.toString();
}

function buildBentoUrl(path, params) {
    const query = buildQuery(params);
    return `https://yvrcookies.mybentosmb.com/${stage}/app${path}?shop=${shop}${query ? `&${query}` : ""}`;
}

function buildArchieUrl(path, params) {
    const query = buildQuery(params);
    return `/apps/archie${path}${query ? `?${query}` : ""}`;
}

function call(path, params = {}, options) {
    return getArchieThemeSettings().then((settings) => {
        const isModalEndpoint = path === "/order/shipping-options";
        const mode = isModalEndpoint ? settings.modalMode : settings.orderMode;
        const url = mode === "archie"
            ? buildArchieUrl(path, params)
            : buildBentoUrl(path, params);

        return fetch(url, options);
    });
}

var productCache = null;
var onceLoaded = [];

function applyMetafieldsToProductForm() {
  const forms = document.querySelectorAll('form.pf-product-form, form.product-form-product-template');

  for (const form of forms) {
    const productID = form.children['product-id']?.value;

    if (typeof productID !== 'string') continue;

    if (product && product.id == productID) {
      injectFormData(form, product);
    } else {

      if (productCache === null) {
        fetchAllProducts();
      }

      if (productCache === null) {
        onceLoaded.push(getProductData.bind(this, form, productID));
      } else {
        getProductData(form, productID);
      }
    }
  }
}

async function fetchAllProducts() {
  const response = await fetch('https://yvrcookie.com/collections/all?view=archie-products');
  productCache = await response.json();

  for (const func of onceLoaded) {
    func();
  }
}

function getProductData(form, productID) {
  const product = productCache.find(item => item.id == productID);

  if (product == null) return;

  injectFormData(form, product);
}

function injectFormData(form, product) {
  const metafieldsToInject = [
    ['end_date', '_unavailableAt'],
    ['start_date', '_availableAt'],
  ];

  for (const [key, name] of metafieldsToInject) {
    const value = product.metafields[key];

    if (value === undefined) continue;

    const inputEl = document.createElement('input');
    inputEl.setAttribute('type', 'hidden');
    inputEl.setAttribute('name', `properties[${name}]`);
    inputEl.setAttribute('value', value);

    form.append(inputEl);
  }
}

document.addEventListener("DOMContentLoaded", applyMetafieldsToProductForm);